import { Button } from '@mui/material';

import { HeaderAction } from '@app/components/ListHeaderActions';

interface CustomButtonProps {
  action: HeaderAction;
}

export const CustomButton = ({ action }: CustomButtonProps) => {
  return (
    <Button
      data-cy="addNew"
      variant={action?.custom?.variant || 'contained'}
      color={action?.custom?.color || 'primary'}
      startIcon={action?.custom?.Icon ? action?.custom?.Icon : null}
      onClick={action?.handler}>
      {action?.custom?.label}
    </Button>
  );
};
